<div style="margin: 20px; min-height: 700px; min-width: 1200px;">
  <h2>Użytkownicy systemu</h2>
  <p-table [value]="users" [paginator]="true" [rows]="15">
    <ng-template pTemplate="emptymessage"><div>Brak danych</div></ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th width="30%">Login</th>
        <th width="30%">Imię i nazwisko</th>
        <th width="30%">Nazwa firmy najemcy</th>
        <th width="10%">Uprawnienie</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
      <tr>
        <td>
          {{user.login}}
        </td>
        <td>
          {{user.name}}
        </td>
        <td>
          {{user.companyName}}
        </td>
        <td>
          <p-checkbox [(ngModel)]="checkedUsers" [value]="user.id"></p-checkbox>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div>
    <p-button class="button" routerLink="../../" label="Zamknij"></p-button>
    <p-button class="button" (click)="save()" label="Zapisz"></p-button>
  </div>
</div>
